import React from 'react';
import DollyTare from './DollyTare';
import AddDollyTareModal from './AddDollyTareModal';
import http from 'utils/http';
import events from 'utils/evemts';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';

class DollyTareContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      action: '',
      dollys: [],
      dollyFields: {},
      dollErrors: {},
      dolly_mail: [],
      dolly_mailFields: {},
      dolly_mailErrors: {},
      filterData: {},
      filterDolly: []
    };
    this.eventSource = null;
  }

  componentDidMount() {
    this.fetchDollyTare();
    this.fetchDollyMail();
    this.eventSource = events('admin', 'dolly');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      let dollys = [...this.state.dollys];
      if (msg.data) {
        if (msg.action == 'ADD') {
          this.setState({ dollys: [...dollys, msg.data] });
        }
        else if (msg.action == 'UPDATE') {
          const index = this.state.dollys.findIndex((dolly) => dolly.id === msg.data.id);
          if (index !== -1) {
            dollys[index] = { ...msg.data };
            this.setState({ dollys: dollys });
          }
        }
        else if (msg.action == 'DELETE') {
          this.setState({ dollys: dollys.filter((dolly) => dolly.id !== msg.data.id) });
        } else if (msg.action == 'dolly_mail') {
          this.setState({ dolly_mail: msg.data?.value || [] });
        }
      }
    };
  }

  fetchDollyTare = () => {
    http.get('dolly').then(({ data }) => {
      this.setState({ dollys: data?.data }, () => {
        this.filter();
      });
    });
  };

  fetchDollyMail = () => {
    http.get('settings?key=dolly_mail').then(({ data }) => {
      if (data.data) {
        let dolly_mail = data.data.find((item) => item.key === 'dolly_mail');
        if (dolly_mail) {
          this.setState({ dolly_mail: dolly_mail?.value || [], });
        }
      }
    });
  };

  filter = () => {
    const { filterData } = this.state;
    let filteredDollys = [...this.state.dollys];
    if (filterData.no) {
      filteredDollys = filteredDollys.filter(dolly => dolly.number && dolly.number.includes(filterData.no));
    }
    this.setState({ filterDolly: filteredDollys });
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      filterData: {
        ...(this.state.filterData || {}),
        [name]: value
      }
    }, () => {
      if (!value || value.trim() === '') {
        this.filter();
      }
    });
  };

  handleOpen = (modal, action, data = {}) => {
    this.setState({
      modal,
      action,
      dollyFields: data
    });
  };

  handleClose = () => {
    this.setState({
      modal: false,
      action: '',
      dollErrors: {},
    });
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      dollyFields: {
        ...this.state.dollyFields,
        [name]: value
      }
    });
  };

  onChangeDollyMail = (e) => {
    const { name, value } = e.target;
    this.setState({
      dolly_mailFields: {
        ...this.state.dolly_mailFields,
        [name]: value
      }
    });
  };

  onAddDollyMail = () => {
    const { dolly_mailFields } = this.state;
    if (!dolly_mailFields.mail) {
      this.setState({
        dolly_mailErrors: {
          ...this.state.dolly_mailErrors,
          mail: true
        }
      });
      return;
    }
    const existing = this.state.dolly_mail.find((item) => item === dolly_mailFields.mail);
    if (existing) {
      this.setState({
        dolly_mailErrors: {
          ...this.state.dolly_mailErrors,
          mail: 'Mail already exists'
        }
      });
      return;
    }
    this.setState({ dolly_mailErrors: {}, });
    const dolly_mail = [...this.state.dolly_mail, dolly_mailFields.mail];
    http.put('setting/dolly_mail', { value: dolly_mail }).then(() => {
      this.setState({
        dolly_mailFields: {},
        dolly_mailErrors: {},
      });
    });
  };

  onRemoveDollyMail = (mail) => {
    const dolly_mail = this.state.dolly_mail.filter((item) => item !== mail);
    http.put('setting/dolly_mail', { value: dolly_mail });
  };

  validation = () => {
    const dollyFields = { ...this.state.dollyFields };
    const error = {};
    let formValid = true;
    if (!dollyFields.prefix || (dollyFields.prefix.trim().length === 0)) {
      formValid = false;
      error.prefix = true;
    }
    if (!dollyFields.number || (dollyFields.number.trim().length === 0)) {
      formValid = false;
      error.number = true;
    }
    if (!dollyFields.wgt || (dollyFields.wgt.trim().length === 0)) {
      formValid = false;
      error.wgt = true;
    }
    if (!dollyFields.expiry || (dollyFields.expiry.trim().length === 0)) {
      formValid = false;
      error.expiry = true;
    }

    this.setState({ dollErrors: error });
    return formValid;
  };

  onSubmit = () => {
    if (this.validation()) {
      if (this.state.dollyFields.id) {
        http.put(`dolly/${this.state.dollyFields.id}`, this.state.dollyFields).then(() => {
          this.handleClose();
        });
      } else {
        http.post('dolly', this.state.dollyFields).then(() => {
          this.handleClose();
        });
      }
    }
  };

  onDelete = (id) => {
    http.delete(`dolly/${id}`).then(() => {
      this.props.setDelete();
    });
  };

  handleDelete = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.onDelete(id),
    });
  };


  render() {
    return (
      <>
        <DollyTare
          dollys={this.state.filterDolly}
          action={this.state.action}
          modal={this.state.modal}
          dolly_mail={this.state.dolly_mail}
          dolly_mailFields={this.state.dolly_mailFields}
          dolly_mailErrors={this.state.dolly_mailErrors}
          onChangeDollyMail={this.onChangeDollyMail}
          onAddDollyMail={this.onAddDollyMail}
          onRemoveDollyMail={this.onRemoveDollyMail}
          handleOpen={this.handleOpen}
          onClose={this.handleClose}
          handleDelete={this.handleDelete}
          filter={this.filter}
          handleFilterChange={this.handleFilterChange}
          filterData={this.state.filterData}
        />

        {this.state.modal === 'dolly_tare' &&
          <AddDollyTareModal
            modal={this.state.modal}
            action={this.state.action}
            onChange={this.onChange}
            onSubmit={this.onSubmit}
            onClose={this.handleClose}
            dollyFields={this.state.dollyFields}
            dollErrors={this.state.dollErrors}
          />
        }
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(null, mapDispatchToProps)(DollyTareContainer);
